module.exports = __webpack_public_path__ + "images/c97c587f17d12a191a6882dc1e9dedd9.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/images/intro_video/cuban_neighbourhood/susan_thumb.jpg
// module id = 172
// module chunks = 24